import AlgoliaIndex from '~/algolia/algolia-index';
import SearchApi from '../../agent/search';
import { AcademyIndexFormatters } from './academy-index-formatters';

const AcademyIndices = {
  ACADEMY_INDEX: new AlgoliaIndex(
    APP_CONSTANTS.ALGOLIA_INDEXES.ACADEMIES,
    {
      attributesToSnippet: ['name', 'title', 'description', 'content', 'section_and_task_titles'],
    },
    AcademyIndexFormatters.formatResult,
    (results) => {
      SearchApi.logSearchResults(results);
      return results;
    },
  ),

  getAll() {
    return [this.ACADEMY_INDEX];
  },
};

export default AcademyIndices;
